<template>
  <div class="pa-12" v-if="items">
    <v-col cols="12">
      <h2>Summary</h2>
      <v-row>
        <v-col cols="3" v-for="item in items" :key="item.id">
          <v-card light>
            <v-card-title>{{ item.doc.title }}</v-card-title>
            <v-card-text>
              <div class="d-flex">
                <div class="preview mb-4">
                  <img class="" :src="item.doc.src" />
                </div>
                <p
                  class="content text-body-1 black--text"
                  v-html="item.doc.summary"
                />
              </div> </v-card-text
          ></v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="11">
      <p class="overline">Part 1</p>
      <h2>Vocabulary</h2>
      <p class="mt-4">Select the words we are happy with</p>

      <v-row>
        <v-col cols="4">
          <h4>Emotions</h4>
          <ul class="select-list">
            <li
              v-for="(item, index) in collectedEmotions"
              :key="`${item}-${index}-emotions`"
              class=""
            >
              <v-checkbox
                :label="item"
                v-model="selectedEmotions"
                :value="item"
              ></v-checkbox>
            </li>
          </ul>
        </v-col>
        <v-col cols="4">
          <h4>Powers</h4>
          <ul class="select-list">
            <li
              v-for="(item, index) in collectedPowers"
              :key="`${item}-${index}-powers`"
              class=""
            >
              <v-checkbox
                :label="item"
                v-model="selectedPowers"
                :value="item"
              ></v-checkbox>
            </li>
          </ul>
        </v-col>
        <v-col cols="4">
          <h4>Attributes</h4>
          <ul class="select-list">
            <li
              v-for="(item, index) in collectedAttributes"
              :key="`${item}-${index}-attributes`"
              class=""
            >
              <v-checkbox
                :label="item"
                v-model="selectedAttributes"
                :value="item"
              ></v-checkbox>
            </li>
          </ul>
        </v-col>
        <v-col cols="12">
          <v-btn color="amber" light @click="saveResults()">Save</v-btn></v-col
        >
        <v-col cols="11">
          <p class="overline">Part 2</p>
          <h2 class="mb-8">
            Use the selected words to generate a new articulation
          </h2>
          <v-card light>
            <v-card-text>
              <v-row>
                <v-col cols="4">
                  <h5 class="mb-2">Selected Emotions</h5>
                  <v-chip
                    v-for="(item, index) in selectedEmotions"
                    :key="`chips-${item}-${index}-emotions`"
                    small
                    class="ma-1"
                    >{{ item }}</v-chip
                  >
                  <h5 class="my-2">Selected Powers</h5>
                  <v-chip
                    v-for="(item, index) in selectedPowers"
                    :key="`chips-${item}-${index}-powers`"
                    small
                    class="ma-1"
                    >{{ item }}</v-chip
                  >
                  <h5 class="my-2">Selected Attributes</h5>
                  <v-chip
                    v-for="(item, index) in selectedAttributes"
                    :key="`chips-${item}-${index}-attributes`"
                    small
                    class="ma-1"
                    >{{ item }}</v-chip
                  >
                </v-col>
                <v-col cols="3">
                  <h5 class="mb-2">Generate an AI Summary</h5>
                  <v-textarea
                    label="Prompt"
                    v-model.trim="prompt"
                    type="text"
                    placeholder=""
                  ></v-textarea>
                  <div class="d-flex">
                    <v-btn color="white" @click="generateSummary()"
                      >Summarise</v-btn
                    >
                  </div>
                </v-col>
                <v-col cols="5">
                  <div class="title black--text" v-html="summary"></div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn
                class="ml-2 mb-4"
                color="amber"
                light
                @click="saveResults()"
                >Save</v-btn
              ></v-card-actions
            >
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
// import lodash from "lodash";
import axios from "axios";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";

export default {
  name: "ResultsMuseumSummary",
  data() {
    return {
      items: null,
      results: null,
      cols: 4,
      summary: "",
      messages: [],
      selectedEmotions: [],
      selectedAttributes: [],
      selectedPowers: [],
      prompt:
        "Apply these characteristics to an organisation and summarise them into a succinct sentence that describes how it might behave",
    };
  },
  props: {
    uid: String,
    id: String,
  },
  watch: {
    id(val) {
      if (val) {
        this.getExercise(val);
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getExercise(this.id);
      this.getResults();
    });
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    collectedEmotions() {
      const arr = [];
      this.items.forEach((item) => {
        arr.push(item.doc.emotion);
      });
      return arr;
    },
    collectedPowers() {
      const arr = [];
      this.items.forEach((item) => {
        arr.push(item.doc.power);
      });
      return arr;
    },
    collectedAttributes() {
      const arr = [];
      this.items.forEach((item) => {
        item.doc.attributes.forEach((attr) => {
          arr.push(attr);
        });
      });
      return arr;
    },
  },
  methods: {
    getExercise(id) {
      this.items = null;
      // get a ref to the exercise and listen to changes
      let ref = fb.museumExCollection.where("pid", "==", id);

      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.items = items;
          }
        })
        .catch(function() {});
    },
    getResults() {
      let ref = fb.museumSummaryCollection
        .where("pid", "==", this.currentProjectModel.id)
        .where("uid", "==", "shared");
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            const {
              selectedAttributes,
              selectedPowers,
              selectedEmotions,
              summary,
            } = items[0].doc;
            this.selectedAttributes = selectedAttributes;
            this.selectedPowers = selectedPowers;
            this.selectedEmotions = selectedEmotions;
            this.summary = summary;
            this.results = items[0];
          }
        })
        .catch(function() {});
    },
    saveResults() {
      let docRef;
      if (this.results && this.results.id) {
        docRef = fb.museumSummaryCollection.doc(this.results.id);
      } else {
        docRef = fb.museumSummaryCollection.doc();
      }
      const {
        selectedEmotions,
        selectedAttributes,
        selectedPowers,
        summary,
      } = this;
      docRef
        .set({
          updatedOn: new Date(),
          id: docRef.id,
          uid: "shared",
          pid: this.currentProjectModel.id,
          doc: {
            selectedEmotions,
            selectedAttributes,
            selectedPowers,
            summary,
          },
        })
        .then(() => {
          console.log("saved");
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
    async generateSummary() {
      const content = [];
      content.push(this.prompt);
      content.push("I condure the emotion of");
      const emotions = this.selectedEmotions.join(",");
      content.push(emotions);

      content.push("My super powers are");
      const powers = this.selectedPowers.join(",");
      content.push(powers);

      content.push("I can be defined as");
      const attributes = this.selectedAttributes.join(",");
      content.push(attributes);

      // // Add user's message to the chat
      this.messages.push({ role: "user", content: content.join(",") });

      try {
        // Send the user's message to the Express server
        const response = await axios.post(
          "https://chat.makelemonade.uk/api/chat",
          {
            messages: this.messages,
          }
        );

        // Add ChatGPT's response to the chat
        const assistantMessage = response.data.choices[0].message;
        this.summary = assistantMessage.content;
      } catch (error) {
        console.error("Error communicating with the server:", error);
      }
    },
  },
};
</script>

<style scoped="">
.preview {
  width: 100px;
  height: 100px;
  overflow: hidden;
  border-radius: 50%;
  position: relative;
  background: #f3f3f3;
  flex-shrink: 0;
  aspect-ratio: 1;
  img {
    width: 100%;

    height: 100%;
    object-fit: cover;
  }
}
.content {
  flex: 1; /* Allow the content to take up remaining space */
  margin-left: 1rem;
}
.select-list {
  padding: 0;
  margin: 0;
  li {
    list-style: none;
    border-bottom: 1px dotted rgba(255, 255, 255, 0.4);
  }
}
</style>
